import { useEffect } from 'react';
import { useApp } from 'App';
import { Loader, Offers, PWA } from 'components';
import { getLoginCount } from 'utils/auth';
import storeService from './store.service';
import AppService from 'app.service';
import { Container, Banner } from './Styles';

const Store = ({ isInstalled, handlePwaButton }) => {
  const { state, setStoreData, setGlobalError } = useApp();
  const { store, storeEvent } = state;

  const getBanner = () => storeService.getBanner({ event: storeEvent, data: store.evs });

  useEffect(() => {
    AppService.getStoreData({ eId: storeEvent })
      .then(store => setStoreData({ store }))
      .catch(() => setGlobalError(true));
  }, []);

  const loginCount = getLoginCount();
  const userAgent = navigator.userAgent;
  const isMobile = 'ontouchstart' in window || navigator.msMaxTouchPoints;
  const isIos = /iPhone|iPad|iPod|Mac/i.test(userAgent);
  const isSafari = /Version\/[\d.]+.*Safari/i.test(userAgent) && !('webkit' in window);
  const isEdge = /Edg/i.test(userAgent);

  return store ? (
    <Container>
      <Banner $banner={getBanner()} />
      <Offers />
      {!isInstalled && isMobile && ((!isIos && !isEdge) || (isSafari && loginCount <= 3)) && (
        <PWA isIos={isIos} handlePwaButton={handlePwaButton} />
      )}
    </Container>
  ) : (
    <Loader fullHeight />
  );
};

export default Store;
